const app = {
  state: {
    pageTitle:"",
    breadcrumb:sessionStorage.getItem('breadcrumb')?JSON.parse(sessionStorage.getItem('breadcrumb')):[],
  },
  mutations:{
    SET_BREADCRUMB: (state, breadcrumb) => {
      state.breadcrumb = breadcrumb
    },
    SET_PAGE_TITLE: (state, pageTitle) => {
      state.pageTitle = pageTitle
    },
  }
};
export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js